import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { ComponentsModule } from '@components/components.module';

@Component({
	selector: 'ui-doc-preview-modal',
	imports: [CommonModule, ComponentsModule],
	templateUrl: './doc-preview-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocPreviewModalComponent {
	drawerService = inject(DrawerService);
	drawerData = inject(DRAWER_DATA);

	onClose() {
		this.drawerService.closeDrawer();
	}
}
